import axios from "axios";

export function getActiveSubdomain() {
  const hostname = window.location.hostname;
  const isMainDomain = hostname === 'dishlco.com' || 
                       hostname === 'www.dishlco.com' || 
                       hostname === 'staging.zplusgroup.in' ||
                       hostname === 'www.staging.zplusgroup.in' ||
                       hostname === 'localhost' || 
                       hostname === '127.0.0.1';
  if (isMainDomain) return null;
  
  if (hostname.endsWith('.dishlco.com')) {
    return hostname.replace('.dishlco.com', '');
  }
  if (hostname.endsWith('.staging.zplusgroup.in')) {
    return hostname.replace('.staging.zplusgroup.in', '');
  }
  
  // Custom domain: return full hostname
  return hostname;
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL.replace(/\/$/, "")}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dishlco_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("dishlco_token");
      localStorage.removeItem("dishlco_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.endsWith("/login")) {
        const activeSub = getActiveSubdomain();
        if (activeSub) {
          window.location.href = "/login";
        } else {
          const parts = window.location.pathname.split('/');
          if (parts[1] === 'site' && parts[2]) {
            window.location.href = `/site/${parts[2]}/login`;
          } else {
            window.location.href = "/login";
          }
        }
      }
    }
    return Promise.reject(err);
  }
);

export function getStoredUser() {
  try {
    const raw = localStorage.getItem("dishlco_user");
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function setAuth(token, user) {
  localStorage.setItem("dishlco_token", token);
  localStorage.setItem("dishlco_user", JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem("dishlco_token");
  localStorage.removeItem("dishlco_user");
}

export function logoutAndRedirect() {
  clearAuth();
  if (!window.location.pathname.startsWith("/login") && !window.location.pathname.endsWith("/login")) {
    const activeSub = getActiveSubdomain();
    if (activeSub) {
      window.location.href = "/login";
      return;
    }
    const parts = window.location.pathname.split('/');
    if (parts[1] === 'site' && parts[2]) {
      window.location.href = `/site/${parts[2]}/login`;
    } else {
      window.location.href = "/login";
    }
  }
}

export function roleHome(role, subdomain = null) {
  const isTenantRole = ["admin", "dealer", "staff", "customer", "agent"].includes(role);
  if (isTenantRole) {
    const targetSubdomain = subdomain || getActiveSubdomain();
    if (targetSubdomain) {
      const path = role === "staff" ? "dealer" : role;
      if (getActiveSubdomain() === targetSubdomain) {
        return `/${path}`;
      }
      return `/site/${targetSubdomain}/${path}`;
    }
  }
  return ({
    superadmin: "/superadmin",
    admin: "/admin",
    dealer: "/dealer",
    staff: "/dealer",
    agent: "/agent",
    customer: "/customer",
  })[role] || "/";
}
  